const metrika = (params) => {
	if(window.yaCounter67772272) {
		window.yaCounter67772272.params(params);
	}
}

export default metrika;